import type { ConfigType } from '@plone/registry';
import SocialNetworksWidget from '../components/Widgets/SocialNetworksWidget/SocialNetworksWidget';

export default function installWidgets(config: ConfigType) {
  config.widgets.widget = {
    ...config.widgets.widget,
    social_networks_widget: SocialNetworksWidget,
  };
  return config;
}
